// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__94Uzj","rightAdornment":"Header_rightAdornment__hBm2e"};